





































































































import Vue from "vue";
var moment = require("moment");

export default Vue.extend({
  props: {
    pointageTime: {
      type: String,
      default: "2020-12-12 00:00",
    },
    maxTime: {
      type: String,
      default: "2020-12-12 00:00",
    },
    minTime: {
      type: String,
      default: "2020-12-12 00:00",
    },
    individuName: {
      type: String,
      default: "",
    },
    temps: {
      type: Object,
      default: () => {},
    },
    typePointage: {
      type: String,
      default: "",
    },
    isPointageGlobal: {
      type: Boolean,
      default: false,
    },
    hasHeureFix: {
      type: Boolean,
      default: false,
    },
    hasPuce:{
       type: Boolean,
      default: false,
    }
    
  },
  data() {
    return {
      time: "2020-12-12 00:00",
      t: 180
    };
  },
  filters: {
    onlyTime: function (temps: string) {
      return moment(temps, "YYYY-MM-DD HH:mm:ss")
              .format("HH:mm");
    },
  },
  mounted() {
    this.time = this.pointageTime;
  },
  methods: {
    getHeure() {
      return moment(this.time, "YYYY-MM-DD HH:mm:ss").format("HH");
    },
    getMinute() {
      return moment(this.time, "YYYY-MM-DD HH:mm:ss").format("mm");
    },
    addHeure() {
      if (
        moment(this.time, "YYYY-MM-DD HH:mm:ss").add(1, "hours").format("YYYY-MM-DD HH:mm:ss") <=
        moment(this.minTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      )
        this.time = moment(this.time, "YYYY-MM-DD HH:mm:ss").add(1, "hours").format("YYYY-MM-DD HH:mm:ss");
    },
    subtractHeure() {
      if (
        moment(this.time, "YYYY-MM-DD HH:mm:ss").subtract(1, "hours").format("YYYY-MM-DD HH:mm:ss") >=
        moment(this.maxTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      )
        this.time = moment(this.time, "YYYY-MM-DD HH:mm:ss")
          .subtract(1, "hours")
          .format("YYYY-MM-DD HH:mm:ss");
    },
    addMinute() {
      if (
        moment(this.time, "YYYY-MM-DD HH:mm:ss").add(1, "minutes").format("YYYY-MM-DD HH:mm:ss") <=
        moment(this.minTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      )
        this.time = moment(this.time, "YYYY-MM-DD HH:mm:ss")
          .add(1, "minutes")
          .format("YYYY-MM-DD HH:mm:ss");
    },
    async fastaddMinute(){
      let t: any
      let i =0
      this.t = 180
      while(i<this.t){
        await new Promise(r => setTimeout(r, 100));
        this.addMinute()
        i++;
      }
      clearInterval(t)
    },
    killFastMinute(){
      console.log('killFastMinute')
      this.t = 0
    },
    subtractMinute() {
      if (
        moment(this.time, "YYYY-MM-DD HH:mm:ss").subtract(1, "minutes").format("YYYY-MM-DD HH:mm:ss") >=
        moment(this.maxTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      )
        this.time = moment(this.time, "YYYY-MM-DD HH:mm:ss")
          .subtract(1, "minutes")
          .format("YYYY-MM-DD HH:mm:ss");
    },
    async fastSubtractMinute(){
      this.t=180
      let t: any
      let i =0
      while(i<this.t){
        await new Promise(r => setTimeout(r, 100));
        this.subtractMinute()
        i++;
      }
      clearInterval(t)
    },
    getSrcAddHour() {
      if (
        moment(this.time, "YYYY-MM-DD HH:mm:ss").add(1, "hours").format("YYYY-MM-DD HH:mm:ss") <=
        moment(this.minTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      )
        return require(`@/assets/pointage/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE.svg`);
      else
        return require(`@/assets/pointage/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE_DESACTIVE.svg`);
    },
    getSrcAddMinute() {
      if (
        moment(this.time, "YYYY-MM-DD HH:mm:ss").add(1, "minutes").format("YYYY-MM-DD HH:mm:ss") <=
        moment(this.minTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      )
        return require(`@/assets/pointage/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE.svg`);
      else
        return require(`@/assets/pointage/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE_DESACTIVE.svg`);
    },
    getSrcSubtractHour() {
      if (
        moment(this.time, "YYYY-MM-DD HH:mm:ss").subtract(1, "hours").format("YYYY-MM-DD HH:mm:ss") >=
        moment(this.maxTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      )
        return require(`@/assets/pointage/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE.svg`);
      else
        return require(`@/assets/pointage/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE_DESACTIVE.svg`);
    },
    getSrcSubtractMinute() {
      if (
        moment(this.time, "YYYY-MM-DD HH:mm:ss").subtract(1, "minutes").format("YYYY-MM-DD HH:mm:ss") >=
        moment(this.maxTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      )
        return require(`@/assets/pointage/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE.svg`);
      else
        return require(`@/assets/pointage/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE_DESACTIVE.svg`);
    },
  },
});
